export default {
  navOpen: false,
  backgroundColor: 'bcb',
  background: 'one',
  sticky: false,
  app: {
    about: [
      {
        type: 'text',
        placeholder: 'First Name',
        name: 'firstName'
      },
      {
        type: 'text',
        placeholder: 'Last Name',
        name: 'lastName'
      },
      {
        type: 'text',
        placeholder: 'Title',
        name: 'title'
      },
      {
        type: 'text',
        placeholder: 'Company Name',
        name: 'company'
      },
      {
        type: 'email',
        placeholder: 'Email Address',
        name: 'email'
      },
      {
        type: 'text',
        placeholder: 'Phone Number',
        name: 'phone'
      }
    ],
    brand: [
      {
        type: 'dropdown',
        placeholder: 'Company Category',
        name: 'category',
        options: [
          'Jewelry',
          'Fashion',
          'Accessories',
          'Beauty',
          'Home',
          'Wellness',
          'Technology'
        ]
      },
      {
        type: 'dropdown',
        placeholder: 'Company Subcategory',
        name: 'sticker',
        options: [
          'First Time IRL',
          'Made With Love',
          'Gives Back',
          'Cult Status',
          'Eureka',
          'Diverse Founder',
          'Family Founded',
          'Inclusive',
          'Female Founder',
          'Local'
        ]
      },
      {
        type: 'text',
        name: 'website',
        placeholder: 'Company Website'
      },
      {
        type: 'text',
        name: 'instagram',
        placeholder: 'Company Instagram'
      },
      {
        type: 'textarea',
        name: 'about',
        placeholder: `Anything else you'd like us to know?`
      }
    ],
    location: [
      {
        type: 'group',
        name: 'location',
        options: [
          {
            type: 'radio',
            name: 'sanFranUnionSquare',
            placeholder: 'San Francisco - Union Square'
          },
          {
            type: 'radio',
            name: 'sanFranHayes',
            placeholder: 'San Francisco - Hayes Valley (Coming Soon)'
          },
          {
            type: 'radio',
            name: 'laWestHollywood',
            placeholder: 'Los Angeles - Abbot Kinney (Coming Soon)'
          }
        ]
      }
    ],
    package: [
      {
        type: 'group',
        name: 'plan',
        options: [
          {
            type: 'radio',
            name: 'community',
            placeholder: 'Half Bay: $550/M + 20%'
          },
          {
            type: 'radio',
            name: 'resident',
            placeholder: 'Full Bay: $850/M + 20%'
          },
          {
            type: 'radio',
            name: 'growth',
            placeholder: 'Anchor: Custom'
          }
        ]
      }
    ]
  }
}
